import { Grid, Button, Box, Typography } from '@mui/material';
import { Modal } from '@care/react-component-lib';
import { ModalMemberSelectionCoreProps } from '@/types';
import { AnalyticsHelper } from '@/utilities/AnalyticsHelper';
import { AnalyticsEventName, CtaLocation, CtaText, ScreenName } from '@/types/enums';
import { LAYOUTS } from '@/constants';

function GreaterCareModalMemberSelection({
  handleDTSeeker,
  handleDTSitter,
  handleModalOnClose,
  isModalOpen,
  modalButtonsText,
  selectedVerticalIcon,
}: ModalMemberSelectionCoreProps) {
  return (
    <Modal
      onClose={() => {
        AnalyticsHelper.logEvent({
          name: AnalyticsEventName.CTA_INTERACTED,
          data: {
            cta_intent: 'Dismiss modal',
            cta_text: CtaText.CLOSE_MODAL,
            cta_location: CtaLocation.VHP_MODAL,
            screen_name: ScreenName.VISITOR_HOMEPAGE,
            enrollment_initiated: false,
          },
        });
        handleModalOnClose();
      }}
      open={isModalOpen}
      maxWidth="xs"
      sx={{
        '& .MuiPaper-root': {
          maxWidth: '475px',
        },
        '& .MuiDialogContent-root': {
          width: '344px',
          margin: '0 auto',
          padding: 0,
        },
      }}>
      <Box sx={{ '& img': { width: '128px' } }} data-testid={`${LAYOUTS.greaterCare}-for-modal`}>
        {selectedVerticalIcon}
      </Box>
      <Typography variant="h2" marginTop="6px">
        I would like to:
      </Typography>
      <Box sx={{ mt: '26px', mb: '21px' }}>
        <Grid
          container
          direction="row"
          display="flex"
          margin="0 auto"
          justifyContent="space-between">
          <Button
            color="primary"
            variant="contained"
            data-testid="findACaregiver"
            sx={{ maxWidth: '160px' }}
            onClick={handleDTSeeker}>
            {modalButtonsText.seeker}
          </Button>
          <Button
            color="primary"
            variant="contained"
            data-testid="findAJob"
            sx={{ maxWidth: '160px' }}
            onClick={handleDTSitter}>
            {modalButtonsText.provider}
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
}

export default GreaterCareModalMemberSelection;
